import { Injectable } from "@angular/core";
import { CanActivate, CanActivateChild, Router, UrlTree } from "@angular/router";
import { filter, map, Observable, switchMap } from "rxjs";
import { TalentPoolConfigService } from "../../features/talent-pool-config/talent-pool-config.service";
import { SettingsService } from "../services/settings.service";

/**
 * Blocks the Talent-Pool routes on stages where the Talent-Pool UI is hidden (currently:
 * production). The decision is derived from {@link TalentPoolConfigService.showTalentPoolUi},
 * which reflects the same stage gate the backend applies to `TalentPoolConfigService.get()`.
 */
@Injectable({ providedIn: "root" })
export class TalentPoolUiGuard implements CanActivate, CanActivateChild {
  constructor(
    private readonly router: Router,
    private readonly settings: SettingsService,
    private readonly talentPoolConfigService: TalentPoolConfigService
  ) {}

  canActivateChild(): Observable<UrlTree | boolean> {
    return this.checkTalentPoolUi();
  }

  canActivate(): Observable<UrlTree | boolean> {
    return this.checkTalentPoolUi();
  }

  private checkTalentPoolUi(): Observable<UrlTree | boolean> {
    return this.settings.isAuthorized$.pipe(
      filter((authorized) => authorized),
      switchMap(() => this.talentPoolConfigService.showTalentPoolUi()),
      map((showTalentPoolUi) => (showTalentPoolUi ? true : this.router.parseUrl("/notfound")))
    );
  }
}
